"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.SelectedLanguageOption=void 0;var a;(function(e){e.ChangeLanguage="change_language",e.Keep="keep"})(a||(exports.SelectedLanguageOption=a={}));
//# sourceMappingURL=SelectedLanguageOption.js.map
